import { render, staticRenderFns } from "./episodes.vue?vue&type=template&id=78a1b3a4"
import script from "./episodes.vue?vue&type=script&lang=js"
export * from "./episodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports